import { useEffect, useState } from "react";
import { getBundles } from "@/lib/api";
import { BundleCard } from "@/components/BundleCard";
import { Skeleton } from "@/components/ui/skeleton";
import { Button } from "@/components/ui/button";

export default function BundlesPage() {
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = () => {
    setLoading(true);
    setError(false);
    getBundles()
      .then(setBundles)
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="pt-12 pb-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-slate-500">Curated Together</span>
          <h1 className="mt-3 font-display text-4xl font-bold tracking-tight text-slate-900 sm:text-5xl">Premium Bundles</h1>
          <p className="mt-3 text-slate-600">Grouped research and educational sets, curated for value and precision.</p>
        </div>
        {error ? (
          <div className="mt-12 flex flex-col items-center gap-4 py-20 text-center">
            <p className="text-slate-600">We couldn't load the bundles right now.</p>
            <Button variant="outline" className="border-slate-200" onClick={load} data-testid="bundles-retry">Try again</Button>
          </div>
        ) : (
          <div className="mt-12 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {loading
              ? Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="aspect-[4/5] rounded-2xl bg-slate-100" />)
              : bundles.map((b, i) => <BundleCard key={b.id} bundle={b} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
